import { render, staticRenderFns } from "./ImageButtonSettings.vue?vue&type=template&id=5c130ba2&scoped=true&"
import script from "./ImageButtonSettings.vue?vue&type=script&lang=js&"
export * from "./ImageButtonSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c130ba2",
  null
  
)

export default component.exports